import { useState, useCallback } from 'react';

export interface FilterState {
  [key: string]: any;
}

export interface FilterConfig {
  [key: string]: {
    type: 'select' | 'input' | 'date' | 'number';
    options?: { label: string; value: any }[];
    placeholder?: string;
    label?: string;
  };
}

export const useFilters = (initialFilters: FilterState = {}) => {
  const [filters, setFilters] = useState<FilterState>(initialFilters);

  const updateFilter = useCallback((key: string, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  const updateFilters = useCallback((newFilters: FilterState) => {
    setFilters(newFilters);
  }, []);

  const clearFilters = useCallback(() => {
    setFilters({});
  }, []);

  const clearFilter = useCallback((key: string) => {
    setFilters((prev) => {
      const newFilters = { ...prev };
      delete newFilters[key];
      return newFilters;
    });
  }, []);

  // Convert filters to Laravel QueryBuilder format
  const getQueryParams = useCallback(() => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        params.append(`filter[${key}]`, value.toString());
      }
    });

    return params;
  }, [filters]);

  // Get filters as URL search params string
  const getQueryString = useCallback(() => {
    return getQueryParams().toString();
  }, [getQueryParams]);

  return {
    filters,
    updateFilter,
    updateFilters,
    clearFilters,
    clearFilter,
    getQueryParams,
    getQueryString,
  };
};
